import { Box } from "@mui/material";

const ParallelLines = () => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "5px",
            flex: 1,
            alignSelf: "stretch"
        }}
    >
        {[0, 1, 2].map((i) => (
            <Box
                key={i}
                sx={{
                    height: "2px",
                    width: "100%",
                    backgroundColor: "secondary.main",
                    borderRadius: "1px"
                }}
            />
        ))}
    </Box>
);

export default ParallelLines;